import { AirMeltAlloy } from "../../core/alloy-types";
import { AirMeltState } from "../air-melt-state";
import * as _ from "lodash";
import Fuse from "fuse.js";

export function filteredProducts(
  products: AirMeltAlloy[],
  state: AirMeltState
): AirMeltAlloy[] {
  const fuse = new Fuse(products, {
    keys: ['category', 'cannonMuskegonTitle', 'commonName', 'tradeName', 
           'astm', 'aerospaceMaterialSpecifications', 'uns', 'din', 'wNr', 
           'afnor', 'carbon', 'manganese', 'silicon', 'chromium', 'nickel', 
           'molybdenum', 'phosphorus', 'sulfur', 'vanadium', 'tungsten', 
           'cobalt', 'copper', 'iron', 'other', 'solidusF', 'liquidousF' ],
    threshold: 0.4
  });

  const searchTerm = state.searchTerm;
  if (typeof(searchTerm) === "string") {
    products = fuse.search(searchTerm).map(({ item }) => item);
  }


  let currentCategories = state.selectedCategories.filter(cat => cat.selected);
  let categoryFiltered = products.filter(p => {
    return currentCategories.map(c => c.value).includes(p.category);
  });

  let industryFiltered = filteredByIndustryName(categoryFiltered, state);

  let siliconFiltered = state.siliconFilterSet
    ? industryFiltered.filter(
        p =>
          p.silicon != null &&
          p.silicon <= state.siliconMax &&
          p.silicon >= state.siliconMin
      )
    : industryFiltered;

  let chromiumFiltered = state.chromiumFilterSet
    ? siliconFiltered.filter(
        p =>
          p.chromium != null &&
          p.chromium <= state.chromiumMax &&
          p.chromium >= state.chromiumMin
      )
    : siliconFiltered;

  let nickelFiltered = state.nickelFilterSet
    ? chromiumFiltered.filter(
        p =>
          p.nickel != null &&
          p.nickel <= state.nickelMax &&
          p.nickel >= state.nickelMin
      )
    : chromiumFiltered;

  let molybdenumFiltered = state.molybdenumFilterSet
    ? nickelFiltered.filter(
        p =>
          p.molybdenum != null &&
          p.molybdenum <= state.molybdenumMax &&
          p.molybdenum >= state.molybdenumMin
      )
    : nickelFiltered;

  let cobaltFiltered = state.cobaltFilterSet
    ? molybdenumFiltered.filter(
        p =>
          p.cobalt != null &&
          p.cobalt <= state.cobaltMax &&
          p.cobalt >= state.cobaltMin
      )
    : molybdenumFiltered;

  let ironFiltered = state.ironFilterSet
    ? cobaltFiltered.filter(
        p =>
          p.iron != null && p.iron <= state.ironMax && p.iron >= state.ironMin
      )
    : cobaltFiltered;

  return ironFiltered;
}

function filteredByIndustryName(
  products: AirMeltAlloy[],
  state: AirMeltState
): AirMeltAlloy[] {
  // if any filters are set, OR selections together
  if (
    0 < state.cmSelections.length ||
    0 < state.commonNameSelections.length ||
    0 < state.tradeNameSelections.length ||
    0 < state.astmSelections.length ||
    0 < state.amsSelections.length ||
    0 < state.unsSelections.length ||
    0 < state.dinSelections.length ||
    0 < state.wnrSelections.length ||
    0 < state.afnorSelections.length
  ) {
    let cmFiltered =
      0 < state.cmSelections.length
        ? products.filter(
            p =>
              p.cannonMuskegonTitle &&
              state.cmSelections.includes(p.cannonMuskegonTitle)
          )
        : [];

    let commonNameFiltered =
      0 < state.commonNameSelections.length
        ? products.filter(
            p =>
              p.commonName && state.commonNameSelections.includes(p.commonName)
          )
        : [];

    let tradeNameFiltered =
      0 < state.tradeNameSelections.length
        ? products.filter(
            p => p.tradeName && state.tradeNameSelections.includes(p.tradeName)
          )
        : [];

    let astmFiltered =
      0 < state.astmSelections.length
        ? products.filter(p => p.astm && state.astmSelections.includes(p.astm))
        : [];

    let amsFiltered =
      0 < state.amsSelections.length
        ? products.filter(
            p =>
              p.aerospaceMaterialSpecifications &&
              state.amsSelections.includes(p.aerospaceMaterialSpecifications)
          )
        : [];

    let unsFiltered =
      0 < state.unsSelections.length
        ? products.filter(p => p.uns && state.unsSelections.includes(p.uns))
        : [];

    let dinFiltered =
      0 < state.dinSelections.length
        ? products.filter(p => p.din && state.dinSelections.includes(p.din))
        : [];

    let wnrFiltered =
      0 < state.wnrSelections.length
        ? products.filter(p => p.wNr && state.wnrSelections.includes(p.wNr))
        : [];

    let afnorFiltered =
      0 < state.afnorSelections.length
        ? products.filter(
            p => p.afnor && state.afnorSelections.includes(p.afnor)
          )
        : [];

    let allFilteredProducts = cmFiltered.concat(
      commonNameFiltered,
      tradeNameFiltered,
      astmFiltered,
      amsFiltered,
      unsFiltered,
      dinFiltered,
      wnrFiltered,
      afnorFiltered
    );

    return _.uniq(allFilteredProducts);
  } else {
    // no filters set, return everything
    return products;
  }
}
